var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 189,
    viewBox: "0 0 128 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4170",
    d: "M100.913 0.845496L127.645 0.84549L29.5156 188.902L0.863281 188.902L100.913 0.845496Z",
    fill: "#201F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardline);
export default __webpack_public_path__ + "static/media/cardline.1c8ee7e161f2a644f344463ddda75032.svg";
export { ForwardRef as ReactComponent };